// Nov/2026: utilidades de "familia visual" para agrupar variantes en el buscador del armador.
// Separa "FAMILIA - COLOR" tolerando "FAMILIA- COLOR" y dobles espacios ("CIERRES  COBRE").
export function splitFamilia(nombre) {
  const n = String(nombre || "").trim();
  let idx = n.lastIndexOf(" - ");
  let len = 3;
  if (idx <= 0) {
    const m = n.match(/^(.*\S)-\s+(\S.*)$/);
    if (m) { idx = m[1].length; len = n.length - m[1].length - m[2].length; }
  }
  if (idx <= 0) return { prefijo: "", color: null, nombre: n };
  return { prefijo: n.substring(0, idx).trim().replace(/\s+/g, " "), color: n.substring(idx + len).trim(), nombre: n };
}

export function prefijoFamilia(nombre) {
  return splitFamilia(nombre).prefijo.toUpperCase();
}

export function primeraPalabra(nombre) {
  const w = String(nombre || "").trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().split(/[\s\-*/]+/)[0] || "";
  return w.length >= 4 && w.endsWith("S") ? w.slice(0, -1) : w;
}

// Medidas/números del nombre ("4CM", "3CM*12CM", "2.5", "#10", "20U") → "4|3|12|2.5|10|20"
function medidasDe(nombre) {
  const n = String(nombre || "").replace(/(\d),(\d)/g, "$1.$2");
  return (n.match(/\d+(?:\.\d+)?/g) || []).map((x) => String(parseFloat(x))).sort().join("|");
}

// Nombre sin el color (para etiquetar una familia cuyos nombres no tienen " - ").
export function nombreSinColor(p) {
  const nombre = String(p?.nombre || "").trim();
  const color = String(p?.color || "").trim();
  if (!color || color.length < 3) return nombre;
  const esc = color.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const out = nombre.replace(new RegExp(`\\s*\\b${esc}\\b`, "i"), "").replace(/\s+/g, " ").trim();
  return out.length >= 4 ? out : nombre;
}

// Dos productos son hermanos solo si comparten familia_key o prefijo, su primera palabra coincide
// Y tienen las mismas medidas (4CM ≠ 2.5CM, 12CM ≠ 18CM, 200D ≠ 300D).
// Evita que una familia_key heredada/errada mezcle cierres dentro de otra familia.
export function sonHermanos(a, b) {
  const fa = (a.familia_key || "").trim().toUpperCase();
  const fb = (b.familia_key || "").trim().toUpperCase();
  const pa = prefijoFamilia(a.nombre);
  const pb = prefijoFamilia(b.nombre);
  const mismaClave = (fa && fa === fb) || (pa && pa === pb);
  if (!mismaClave) return false;
  if (primeraPalabra(a.nombre) !== primeraPalabra(b.nombre)) return false;
  return medidasDe(a.nombre) === medidasDe(b.nombre);
}
